import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { HomeService } from 'src/app/modules/home/home.service';
import { IResponse } from 'src/app/shared/models/app';
import { DayboardDateService } from '../../dayboard-date.service';
import { SessionStorageService } from 'ngx-webstorage';
import { CacheConstant } from 'src/app/core/cache/cache.constant';
import { CacheResolverService } from 'src/app/core/cache/cache-resolver.service';

@Component({
    selector: 'nphs-user-rejected-request',
    templateUrl: './rejected-request.component.html',
    styleUrls: ['./rejected-request.component.scss'],
    standalone: false
})
export class RejectedRequestComponent implements OnInit {

  notificationData = [];

  constructor(private homeService: HomeService,
    private sessionStorage: SessionStorageService,
    private cache: CacheResolverService) { }

  ngOnInit(): void {
    this.Init()
  }

  private Init() {
    this.getNotificationData();
  }

  getShipto() {
    const date = this.cache.get('currDate');
    const data = {

      startDate: moment(date).startOf("day").utc().format(),
      customerShipToNum: this.sessionStorage.retrieve(CacheConstant.SessionStorageData.ShipTo),
    }
    return data
  }

  private getNotificationData() {
    let data = this.getShipto();
    this.homeService.getNotificationDetails(data).subscribe((response: IResponse) => {
      let transformedData = this.transformNotification(response.data);

    })
  }

  transformNotification(response) {
    this.notificationData = response;
    let notificationData = [];
    if (response) {
      response.forEach((item, index) => {
        notificationData[index] = (item);
        notificationData[index].calibrationTime = moment(new Date(item.calibrationTime)).format('HH:mm');
        notificationData[index].rejectTime = moment(new Date(item.rejectTime)).format('MM/DD/YYYY HH:mm')
      })
    }
    return notificationData;
  }

  clear(data, all) {
    var rejectRequestMessageNumbers = []
    if (all) {
      data.forEach((message) => {
        rejectRequestMessageNumbers.push(message.rejectedMsgNumber);
      })
    }
    else {
      var index = -1;
      rejectRequestMessageNumbers.push(data[0].rejectedMsgNumber);
      this.notificationData.forEach((message, ind) => {
        if (message.rejectedMsgNumber == data[0].rejectedMsgNumber) {
          index = ind;
        }
      })
    }
    var retVal = {
      rejectRequestMessageNumbers: rejectRequestMessageNumbers,
      customerShipToNum: this.sessionStorage.retrieve(CacheConstant.SessionStorageData.ShipTo),
    }
    this.homeService.dismissMessage(retVal).subscribe((response: IResponse) => {
      this.notificationData.splice(index, 1);
      this.getNotificationData();

      // if (!response.hasError && all) {
      //   this.notificationData = [];
      // }

      // else if (!response.hasError) {
      //   this.notificationData.splice(index, 1);
      // }
    })
  }
}
